import { ArrowForwardIos } from '@mui/icons-material';
import { Typography, Stack } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { theme } from '../../../../theme';

function InsightBox({ draftId, insight, setSelectedTab }) {
    function getInsightTitle() {
        switch (insight.type) {
        case 'optimization_opportunity':
            if (insight.data.value > 100000) {
                return `${(insight.data.value / 100).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                    style: 'currency',
                    currency: 'USD',
                })} Unreviewed Opportunity`;
            } else {
                return 'Unreviewed Opportunity';
            }
        case 'high_category_cost':
            return `High Supply Cost - ${insight.data.category}`
        }
    }

    function calculatePercentageOver(largerSpend, smallerSpend) {
        if (smallerSpend >= largerSpend) {
            return 0;
        }

        if (largerSpend === 0) {
            return largerSpend === 0 ? 0 : 100; // If both are zero, return 0%, else return 100%
        }
        return ((largerSpend - smallerSpend) / smallerSpend) * 100;
    }

    function getInsightDescription() {
        switch (insight.type) {
        case 'optimization_opportunity':
            return `This card has ${insight.data.count} optimizations for you to review.`;
        case 'high_category_cost':
            return `Card supply cost is ${calculatePercentageOver(insight.data.physician_spend, insight.data.average_spend).toFixed()}% above peer average.`;
        default:
            return '';
        }
    }

    function handleNavigation() {
        switch (insight.type) {
        case 'optimization_opportunity':
            setSelectedTab('optimizations');
            break;
        case 'high_category_cost':
            window.location.href = `/physician/drafts/${draftId}/comparison?category=${insight.data.category}`;
            break;
        default:
            break;
        }
    }

    return (
        <Box onClick={handleNavigation} p={2} borderRadius='8px' backgroundColor='white' boxShadow={2} sx={{ cursor: 'pointer' }}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Stack spacing={1}>
                    <Typography variant='heavy' fontSize='14px'>{getInsightTitle()}</Typography>
                    <Typography variant='normal' fontSize='12px'>{getInsightDescription()}</Typography>
                </Stack>
                <ArrowForwardIos fontSize='small' style={{ color: `${theme.palette.subtext.main}` }} />
            </Stack>
        </Box>
    );
}

export default InsightBox;
